module.exports = __webpack_public_path__ + "img/common.eb7e3a4e.png";